export { default } from './src/insert-link';
